module.exports = __webpack_public_path__ + "img/A4.0736d456.svg";